<template>
  <app-content class="h-panel">
    <div class="h-panel-bar">
      <span class="h-panel-title">
        <template v-if="subject">{{subject.name}}</template>
        <template v-if="subject && subject.unit">(单位:{{subject.unit}})</template> - 明细账
      </span>
    </div>
    <div class="margin-right-left margin-top">
      <account-period-selector
          @confirm="handleConfirm"
          @date-change="handleDateChange"
          :current-subject="subject"
          :subject-list="subjectList"
      />
      <div class="float-right">
        <Button @click="exportExcel">导出</Button>
      </div>
    </div>
    <Row class="h-panel-body" type="flex" :space-x="10">
      <Cell :flex="1" style="overflow-x: auto;">
        <!-- 外部滚动容器：保留原有样式，仅添加position: relative -->
        <div style="max-height: 670px; overflow-y: auto; position: relative;">
          <!-- 普通表格（无数量金额） -->
          <div class="table-container" v-if="!showNumPrice">
            <!-- 表头：添加sticky固定，保留原有所有样式 -->
            <table class="cus-table" style="position: sticky; top: 0; z-index: 10;">
              <thead class="header">
              <tr>
                <td width="100">日期</td>
                <td width="100">凭证字号</td>
                <td width="150">科目</td>
                <td width="200">摘要</td>
                <td width="100" class="text-right">借方</td>
                <td width="100" class="text-right">贷方</td>
                <td width="80" class="text-center">方向</td>
                <td width="120" class="text-right">余额</td>
              </tr>
              </thead>
            </table>
            <!-- 内容表格：保留原有所有样式，仅分离表头 -->
            <table class="cus-table">
              <tbody>
              <tr v-for="(item,i) in datalist" :key="item.subjecId"  @click="onClick(i)" :class="{ selected: selectedRow === i }">
                <td width="100">{{item.voucherDate}}</td>
                <td width="100">
                  <router-link v-if="item.voucherId" :to="{name:'VoucherForm',params:{voucherId:item.voucherId}}">{{item.word}}-{{item.code}}</router-link>
                </td>
                <td width="150">{{item.subjectName}}</td>
                <td width="200">{{item.summary}}</td>
                <td width="100" class="text-right">{{item.debitAmount|numFormat}}</td>
                <td width="100" class="text-right">{{item.creditAmount|numFormat}}</td>
                <td width="80" class="text-center">{{item.balanceDirection}}</td>
                <td width="120" class="text-right">{{item.balance|numFormat}}</td>
              </tr>
              <tr v-if="!datalist.length">
                <td colspan="8" class="text-center padding">暂无数据</td>
              </tr>
              </tbody>
            </table>
          </div>

          <!-- 数量金额表格 -->
          <div class="table-container" v-else>
            <!-- 表头：添加sticky固定，保留原有所有样式 -->
            <table class="cus-table" style="width: 1550px; position: sticky; top: 0; z-index: 10;">
              <thead class="header">
              <tr>
                <td rowspan="2" width="100">日期</td>
                <td rowspan="2" width="100">凭证字号</td>
                <td rowspan="2" width="150">科目</td>
                <td rowspan="2" width="200">摘要</td>
                <td colspan="3">借方发生额</td>
                <td colspan="3">贷方发生额</td>
                <td colspan="4">余额</td>
              </tr>
              <tr>
                <td width="100" class="text-right">数量</td>
                <td width="100" class="text-right">单价</td>
                <td width="100" class="text-right">金额</td>
                <td width="100" class="text-right">数量</td>
                <td width="100" class="text-right">单价</td>
                <td width="100" class="text-right">金额</td>
                <td width="80" class="text-center">方向</td>
                <td width="100" class="text-right">数量</td>
                <td width="100" class="text-right">单价</td>
                <td width="120" class="text-right">金额</td>
              </tr>
              </thead>
            </table>
            <!-- 内容表格：保留原有所有样式，仅分离表头 -->
            <table class="cus-table" style="width: 1550px;">
              <tbody>
              <tr v-for="item in datalist" :key="item.subjecId">
                <td width="100">{{item.voucherDate}}</td>
                <td width="100">
                  <router-link v-if="item.voucherId" :to="{name:'VoucherForm',params:{voucherId:item.voucherId}}">{{item.word}}-{{item.code}}</router-link>
                </td>
                <td width="150" class="nowrap">{{item.subjectName}}</td>
                <td width="200" class="nowrap">{{item.summary}}</td>
                <td width="100" class="text-right">{{item.debitAmount&&item.balanceDirection=='借'?item.num:''}}</td>
                <td width="100" class="text-right">{{item.debitAmount&&item.balanceDirection=='借'?item.price:''}}</td>
                <td width="100" class="text-right">{{item.debitAmount|numFormat}}</td>
                <td width="100" class="text-right">{{item.creditAmount&&item.balanceDirection=='贷'?item.num:''}}</td>
                <td width="100" class="text-right">{{item.creditAmount&&item.balanceDirection=='贷'?item.price:''}}</td>
                <td width="100" class="text-right">{{item.creditAmount|numFormat}}</td>
                <td width="80" class="text-center">{{item.balanceDirection}}</td>
                <td width="100" class="text-right">{{item.numBalance|numFormat}}</td>
                <td width="100" class="text-right">{{item.price|numFormat}}</td>
                <td width="120" class="text-right">{{item.balance|numFormat}}</td>
              </tr>
              <tr v-if="!datalist.length">
                <td colspan="14" class="text-center padding">暂无数据</td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </Cell>
      <Cell v-width="200">
        <Tree
            v-model="subjectId"
            @select="subjectSelect"
            :option="param"
            ref="subjectTree"
            filterable
            selectOnClick
            className="h-tree-theme-row-selected">
        </Tree>
      </Cell>
    </Row>
  </app-content>
</template>

<script>
import * as XLSX from "xlsx-js-style";

export default {
  name: 'DetailedAccounts',
  data() {
    return {
      loading: false,
      param: {
        keyName: 'id',
        parentName: 'parentId',
        titleName: 'subjectCodeName',
        dataMode: 'list',
        datas: []
      },
      datalist: [],
      subjectId: null,
      showNumPrice: false,
      numPriceDisabled: true,
      accountDate: null,
      subject: null,
      showCode: false,
      selectedRow: null,
      startDate: null,
      endDate: null,
      formattedStartDate: null,
      formattedEndDate: null, // 新增：统一管理格式化后的结束日期
      loadListTimer: null,
      subjectList: [],
    };
  },
  watch: {
    subject() {
      let org = this.showNumPrice;
      if (this.subject.unit) {
        this.numPriceDisabled = false;
        this.showNumPrice = true;
      } else {
        this.showNumPrice = false;
      }
      if (org == this.showNumPrice) {
        this.loadList();
      }
    },
    showNumPrice() {},
  },
  created() {
    this.loadSubject();
  },
  methods: {
    // ========== 关键修改1：重构日期格式化方法，强制返回当月1号 ==========
    formatDateToFirstDay(monthStr) {
      const [year, month] = monthStr.split('-').map(Number);
      const firstDay = new Date(year, month - 1, 1); // 强制设为当月1号
      return `${year}-${String(month).padStart(2, '0')}-01`; // 固定格式：YYYY-MM-01
    },

    handleDateChange({ startMonth, endMonth }) {
      // 处理开始日期：强制设为当月1号
      if (startMonth) {
        this.formattedStartDate = this.formatDateToFirstDay(startMonth);
        const [year, month] = startMonth.split('-').map(Number);
        this.startDate = new Date(year, month - 1, 1);
      }

      // 处理结束日期：强制设为当月1号（不再是月末）
      if (endMonth) {
        this.formattedEndDate = this.formatDateToFirstDay(endMonth);
        const [year, month] = endMonth.split('-').map(Number);
        this.endDate = new Date(year, month - 1, 1);
      }

      console.log('起始日期（格式化）:', this.formattedStartDate);
      console.log('结束日期（格式化）:', this.formattedEndDate); // 现在始终是1号
    },

    handleConfirm(params) {
      console.log('确认所有参数:', params);
      // ========== 关键修改2：结束日期不再用月末，强制设为当月1号 ==========
      this.formattedStartDate = this.formatDateToFirstDay(params.startMonth);
      this.formattedEndDate = this.formatDateToFirstDay(params.endMonth); // 强制1号
      this.selectedSubjectFromComponent = params.subject;

      // 同步科目到Tree组件
      if (params.subject && params.subject.id) {
        this.subjectId = params.subject.id;
        this.subject = {
          id: params.subject.id,
          code: params.subject.code,
          name: params.subject.name,
          unit: this.subject.unit || '',
          ...params.subject
        };
      }

      // 执行查询
      this.loadList();
    },

    // ========== 关键修改3：删除生成月末日期的getMonthLastDay方法（不再需要） ==========

    onClick(i) {
      this.selectedRow = this.selectedRow === i ? -1 : i;
    },

    exportExcel() {
      this.$api.accountbook.loadVoucherDetails({
        accountDate: this.accountDate,
        subjectId: this.subjectId,
        showNumPrice: this.showNumPrice,
        subjectCode: this.subject.code
      }).then(({data}) => {
        this.datalist = data;
        const tableData = [
          ['日期', '凭证字号', '科目', '摘要', '借方', '贷方', '方向', '余额'],
        ];
        this.datalist.forEach((item) => {
          tableData.push([
            item.voucherDate,
            item.word ? item.word + '-' + item.code : '',
            item.subjectName,
            item.summary,
            item.debitAmount ? item.debitAmount : '',
            item.creditAmount ? item.creditAmount : '',
            item.balanceDirection,
            item.balance
          ]);
        });

        const wb = XLSX.utils.book_new();
        const ws = XLSX.utils.aoa_to_sheet(tableData);

        Object.keys(ws).forEach((key) => {
          if (['A1', 'B1', 'C1', 'D1', 'E1', 'F1', 'G1', 'H1'].includes(key)) {
            ws[key].s = {
              font: {name: '仿宋', sz: 14, bold: true},
              alignment: {horizontal: 'center', vertical: 'center', wrapText: true},
              border: {top: {style: 'thin'}, bottom: {style: 'thin'}, left: {style: 'thin'}, right: {style: 'thin'}}
            };
          } else if (key.match(/^[A-H]/)) {
            ws[key].s = {
              font: {name: '宋体', sz: 12, bold: false},
              border: {top: {style: 'thin'}, bottom: {style: 'thin'}, left: {style: 'thin'}, right: {style: 'thin'}},
            };
          }
        });

        ws['!cols'] = [
          {wpx: 100}, {wpx: 100}, {wpx: 200}, {wpx: 200},
          {wpx: 100}, {wpx: 100}, {wpx: 50}, {wpx: 100}
        ];

        XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
        XLSX.writeFile(wb, '明细账.xlsx');
      });
    },

    async loadSubject() {
      this.datalist = [];
      const {data} = await this.$api.accountbook.loadSubject({accountDate: this.accountDate});
      const formattedData = data.map(subject => ({
        id: subject.id,
        subjectCode: subject.code,
        subjectName: subject.name,
        subjectCodeName: subject.code + " " + subject.name,
        subjectFullName: subject.subjectFullName || subject.name,
        ...subject
      }));
      this.subjectList = formattedData;
      this.$set(this.param, "datas", formattedData);
      if (formattedData.length) {
        this.subjectId = formattedData[0].id;
        this.subject = formattedData[0];
      }
    },

    loadList() {
      if (this.loadListTimer) {
        clearTimeout(this.loadListTimer);
      }
      this.loadListTimer = setTimeout(() => {
        this.loading = true;
        let params = {
          startDate: this.formattedStartDate,
          endDate: this.formattedEndDate, // 现在始终是1号
          subjectId: this.subjectId,
          showNumPrice: this.showNumPrice,
          subjectCode: this.subject.code || '',
        };
        this.$api.accountbook.loadVoucherDetailsByDate(params).then(({data}) => {
          this.datalist = data;
        }).finally(() => {
          this.loading = false;
          this.loadListTimer = null;
        });
      }, 50);
    },

    subjectSelect(node) {
      this.subject = node;
      this.subjectId = node.id;
    }
  }
};
</script>

<style scoped lang="less">
.cus-table {
  width: 100%;
  border-collapse: collapse;
}

.cus-table td {
  border: 1px solid #e8e8e8;
  padding: 8px 8px;
}

.cus-table tr {
  background: #ffffff;
}

.cus-table tr.selected {
  background: rgba(31, 165, 227, 0.2);
}

.cus-table .header tr {
  background: #f5f7fa;
}

.table-container {
  position: relative;
  margin-bottom: 10px;
}

.cus-table tbody tr:first-child td {
  border-top: 1px solid #e8e8e8;
}

.nowrap {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.text-right {
  text-align: right;
}

.text-center {
  text-align: center;
}

.padding {
  padding: 10px 0;
}
</style>